<app-dialog-layout [loading]="false">
  <ng-container content>
    <cpb-list-renderer class="gray-lines" [context]="{ order_operation_id: orderOperationId }" [key]="listKey">
    </cpb-list-renderer>
  </ng-container>
</app-dialog-layout>
